import styled from "styled-components";

export const CardContainer = styled.div`
  background: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 280px;
  justify-content: flex-end;
  padding: 12px 14px;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
    pointer-events: none;
    z-index: 1;
    border-bottom-left-radius: ${({ borderRadius }) => `${borderRadius}px`};
    border-bottom-right-radius: ${({ borderRadius }) => `${borderRadius}px`};
  }
`;

export const CardHeading = styled.h1`
  margin: 0;
  font-size: 22px;
  color: white;
  font-weight: 500;
  z-index: 2;
`;

export const CardParagraph = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  white-space: pre-wrap;
  z-index: 2;
`;
